/**
 * Pagination Component
 *
 * A reusable pagination component styled to match ActiveAdmin design.
 * Used across AirdropHistory, ReverseAirdrop, and wallet tables.
 */

import React from "react";
import { calculatePaginationRange, getPaginationInfo } from "../utils";
import { colors, paginationStyles } from "../styles";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  totalItems,
  itemsPerPage,
}) => {
  if (totalPages <= 1) return null;

  const { startItem, endItem } = getPaginationInfo(
    currentPage,
    itemsPerPage,
    totalItems,
  );
  const pages = calculatePaginationRange(currentPage, totalPages);

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div style={paginationStyles.container}>
      <div style={paginationStyles.info}>
        Displaying items <b style={{ color: colors.primary }}>{startItem}</b> -{" "}
        <b style={{ color: colors.primary }}>{endItem}</b> of{" "}
        <b style={{ color: colors.primary }}>{totalItems}</b> in total
      </div>
      <nav style={paginationStyles.nav}>
        <span
          onClick={handlePrevious}
          style={{
            ...paginationStyles.navButton,
            color: currentPage === 1 ? colors.gray500 : colors.white,
            background: currentPage === 1 ? colors.gray300 : colors.primary,
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
          }}
        >
          ‹ Prev
        </span>
        {pages.map((page) => (
          <span
            key={page}
            onClick={() => onPageChange(page)}
            style={{
              ...paginationStyles.pageButton,
              fontWeight: currentPage === page ? 700 : 600,
              color: currentPage === page ? colors.white : colors.primary,
              background: currentPage === page ? colors.primary : colors.white,
              border: `2px solid ${
                currentPage === page ? colors.primary : colors.borderLight
              }`,
              cursor: currentPage === page ? "default" : "pointer",
            }}
          >
            {page}
          </span>
        ))}
        <span
          onClick={handleNext}
          style={{
            ...paginationStyles.navButton,
            color: currentPage === totalPages ? colors.gray500 : colors.white,
            background:
              currentPage === totalPages ? colors.gray300 : colors.primary,
            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
          }}
        >
          Next ›
        </span>
      </nav>
    </div>
  );
};

export default Pagination;
